export default __webpack_public_path__ + "static/media/tiktok.796f0100.svg";